/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { NavButton } from "@farmlands/shadcn-ui";
import { ChevronRight, LucideIcon } from "lucide-react";
import { FC, type JSX, ReactNode } from "react";

import { ScrollYPositionKeys } from "../../../../util/consts";
import { saveScrollYPosition } from "../../../../util/helpers";

export interface IAccountMenuItemProps {
  label: string;
  icon: LucideIcon;
  testId: string;
  scrollYPosition?: ScrollYPositionKeys;
  onClick: () => void;
  children?: ReactNode;
}

const AccountMenuItem: FC<IAccountMenuItemProps> = ({
  label,
  icon: Icon,
  testId,
  scrollYPosition,
  onClick,
  children,
}: IAccountMenuItemProps): JSX.Element => {
  const handleClick = (): void => {
    if (scrollYPosition) {
      saveScrollYPosition({ sessionStorageKey: scrollYPosition, position: 0 });
    }
    onClick();
  };

  return (
    <NavButton onClick={handleClick} data-testid={testId}>
      <Icon aria-hidden className="size-5" />
      <span className="flex-1 truncate">{label}</span>
      <ChevronRight aria-hidden className="ml-auto size-4" />
      {children}
    </NavButton>
  );
};

export default AccountMenuItem;
